import numbro from "numbro";
import { round, isFunction } from "lodash";

export function formatCurrency(amount: number | string, mantissa = 2) {
  return numbro(+amount).formatCurrency({
    mantissa,
    thousandSeparated: true,
  });
}

export function formatCurrencyPrefix(amount: number | string, mantissa = 2) {
  return numbro(+amount).formatCurrency({
    mantissa,
    average: true,
    optionalMantissa: true,
    currencyPosition: "prefix",
  });
}

export function formatPercentage(number: number | string, mantissa = 2) {
  return numbro(+number).format({
    mantissa,
    output: "percent",
  });
}

export function formatAmount(amount: number | string) {
  return round(+amount, 2);
}

export const boolToEnglish = (val: unknown) => {
  if (val) {
    return "Yes";
  }
  return "No";
};

interface ValueMeta {
  format?: string | ((data: unknown) => unknown);
}

export function formatValue(meta: ValueMeta, data: unknown) {
  if (!meta.format) return data;

  if (isFunction(meta.format)) {
    return meta.format(data);
  }

  switch (meta.format) {
    case "currency":
      return formatCurrency(data as number | string);
    case "percentage":
      return formatPercentage(data as number | string);
    case "boolean":
      return boolToEnglish(data);

    default:
      return data;
  }
}
